<template>
  <div>
    <div class="newsDetial-header">
      <div class="newsDetial-title">合同到期人员</div>
      <blank height="15"> </blank>
      <prompts>
        为了保证数据的实时性减少数据库的冗余数据，系统将在消息陈列2个月后主动清除消息。
      </prompts>
      <blank height="30"> </blank>
    </div>
    <div class="oa-layout-content">
      <div class="search-flex mb20">
        <div class="search-flex-item mr20">
          <span>姓名或身份证号：</span>
          <a-input
            placeholder="请输入姓名"
            class="w300"
            v-model="queryForm.idCardNumber"
          />
        </div>

        <div class="search-flex-item">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="personList"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="position" slot-scope="text">{{
          getByTypeName(text, positionList)
        }}</span>
        <span slot="newContractType" slot-scope="text">{{
          getByTypeName(text, contractTypeList)
        }}</span>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record.id)">
            查看
          </a-button>
          <a-divider type="vertical" />
          <a-button type="link" class="btn-link" @click="add(record.id)">
            修改
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'number',
    key: 'number',
    width: 80,
    align: 'center'
  },
  {
    title: '员工编号',
    dataIndex: 'personalNumber',
    key: 'personalNumber',

    align: 'center'
  },
  {
    title: '姓名',
    dataIndex: 'fullName',
    key: 'fullName',
    ellipsis: true,
    width: 100,
    align: 'left'
  },
  {
    title: '所在部门',
    dataIndex: 'organizationName',
    key: 'organizationName',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '身份证号',
    dataIndex: 'idCardNumber',
    key: 'idCardNumber',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '行政职务',
    dataIndex: 'position',
    key: 'position',
    scopedSlots: { customRender: 'position' },
    ellipsis: true,
    width: 100,
    align: 'left'
  },
  {
    title: '任现职级时间',
    dataIndex: 'positionTime',
    key: 'positionTime',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '最新签订合同时间',
    dataIndex: 'newContractExpirationTime',
    key: 'newContractExpirationTime',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '最新签订合同类型',
    dataIndex: 'newContractType',
    key: 'newContractType',
    scopedSlots: { customRender: 'newContractType' },
    ellipsis: true,
    align: 'left'
  },
  // {
  //   title: '合同到期时间',
  //   dataIndex: 'contractExpirationTime',
  //   key: 'contractExpirationTime',
  //   ellipsis: true,
  //   align: 'left'
  // },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    ellipsis: true,
    align: 'left',
    width: 120
  }
]
import { remindList } from './api/api'
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      queryForm: {},
      columns,
      page: 1,
      total: 0,
      size: 10,
      personList: [],
      loading: false
    }
  },
  created() {
    this.listByType()
    //劳动合同类型
    this.getcontractType()
    this.load()
  },
  computed: {
    ...mapState({
      contractTypeList: (state) => state.bytype.contractTypeList, //劳动合同类型
      positionList: (state) => state.bytype.positionList //职级
    })
  },
  methods: {
    ...mapActions(['getposition', 'getcontractType']),
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    // 获取当前页面所需字典表
    listByType() {
      //行政职务
      this.getposition()
    },
    load() {
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      remindList(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.personList = res.data.data
          this.total = res.data.count
        }
      })
    },
    goDetial(id) {
      this.$router.push({
        path: '/PersonnelDetails',
        query: {
          id
        }
      })
    },
    add(id) {
      this.$router.push({
        path: '/addPersonnel',
        query: {
          id
        }
      })
    },
    pageChange(pageNumber) {
      this.page = pageNumber
      this.load()
    },

    cancel() {
      //取消
      this.queryForm = {}
    },
    subMit() {
      //搜索
      this.page = 1
      this.load()
    }
  }
}
</script>
<style lang="scss" scoped>
.newsDetial-header {
  background: #fff;
  padding: 0 40px;
  .newsDetial-title {
    height: 26px;
    color: rgba(56, 56, 56, 1);
    font-size: 18px;
    line-height: 26px;
    font-weight: bold;
  }
}
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PersonnelManagement/expireList.vue